import { SCREENING_CODES } from "./screeningQuestionsData";

export const patientScreeningSectionTitle = {
  [SCREENING_CODES.how_can_we_help]: "How can I help?",
  [SCREENING_CODES.getting_to_know_you]: "The basics",
  [SCREENING_CODES.your_health_history]: "Your health story",
  [SCREENING_CODES.asrs]: "Focus screener",
  [SCREENING_CODES.phq9]: "Mood screener",
  [SCREENING_CODES.gad7]: "Worry screener",
  [SCREENING_CODES.more_about_you]: "More about you",
  [SCREENING_CODES.supplemental_questions]: "Supplemental questions",
} as const;

export const providerScreeningSectionTitle = {
  [SCREENING_CODES.how_can_we_help]: "How can I help?",
  [SCREENING_CODES.getting_to_know_you]: "The basics",
  [SCREENING_CODES.your_health_history]: "Your health story",
  [SCREENING_CODES.asrs]: "ASRS",
  [SCREENING_CODES.phq9]: "PHQ-9",
  [SCREENING_CODES.gad7]: "GAD-7",
  [SCREENING_CODES.more_about_you]: "More about you",
  [SCREENING_CODES.supplemental_questions]: "Supplemental questions",
} as const;
